(() => {
  const form = document.getElementById('LumiqCeylonForm');
  if (!form) return;
  const choices = form.querySelector('[data-ceylon-choices]');
  const quantity = form.elements.quantity;
  const plan = form.querySelector('[name="selling_plan"]');
  const panel = form.querySelector('[data-frequency-panel]');
  const total = form.querySelector('[data-purchase-total]');
  const error = form.querySelector('[data-purchase-error]');
  const submit = form.querySelector('[type="submit"]');
  let busy = false;
  const sync = () => {
    const mode = form.querySelector('[name="purchase_choice"]:checked')?.value || 'single';
    const subscription = mode === 'subscription' && !!plan;
    quantity.value = mode === 'kit' ? '3' : mode === 'kit5' ? '5' : '1';
    if (plan) {
      plan.disabled = !subscription;
      panel.hidden = !subscription;
      const option = plan.selectedOptions[0];
      form.querySelector('[data-subscription-price]').textContent = option.dataset.price;
      form.querySelector('[data-subscription-summary]').textContent = option.textContent + ' · ' + option.dataset.price;
    }
    total.textContent = subscription ? plan.selectedOptions[0].dataset.price : total.dataset[mode] || total.dataset.single;
    document.querySelectorAll('[data-ceylon-sticky-price]').forEach(el => { el.textContent = total.textContent; });
    document.querySelectorAll('[data-subscription-gift]').forEach(gift => {
      gift.classList.toggle('is-unlocked', subscription);
      gift.classList.toggle('is-locked', !subscription);
    });
    document.querySelectorAll('[data-gift-status]').forEach(el => { el.hidden = !subscription; });
  };
  choices.disabled = false;
  form.addEventListener('change', sync);
  sync();
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || submit.disabled) return;
    sync();
    busy = true;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    error.hidden = true;
    try {
      const payload = new FormData(form);
      payload.delete('purchase_choice');
      if (plan?.disabled) payload.delete('selling_plan');
      if (!window.LumiqCartDrawer) throw Error(error.dataset.fallback);
      await window.LumiqCartDrawer.add(payload, submit);
    } catch (failure) {
      error.textContent = failure.message || error.dataset.fallback;
      error.hidden = false;
    } finally {
      busy = false;
      submit.disabled = false;
      form.setAttribute('aria-busy', 'false');
    }
  });
  document.querySelectorAll('.sticky-atc button,[id^="SectionAtcBtn-"]').forEach(button => {
    button.disabled = submit.disabled;
    button.addEventListener('click', event => { event.preventDefault(); form.requestSubmit(submit); });
  });
  const sticky = document.querySelector('.sticky-atc');
  if (sticky) new IntersectionObserver(entries => {
    sticky.classList.toggle('naturogy-sticky-visible', !entries[0].isIntersecting && form.getBoundingClientRect().top < 0);
  }).observe(form);
})();
